import { render, staticRenderFns } from "./SoThuTienGuiNganHang.vue?vue&type=template&id=7f9362f0&"
import script from "./SoThuTienGuiNganHang.vue?vue&type=script&lang=js&"
export * from "./SoThuTienGuiNganHang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports